export default __webpack_public_path__ + "static/media/Loading_icon.69a5aa2a.gif";